import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import withResponsiveWrapper from '../../../../decorators/withResponsiveWrapper';
import Carousel from '../../../Carousel';
import Link from '../../../Link';
import { mapLinkToDisplayCatalog } from '../../../../helpers/url';
// eslint-disable-next-line css-modules/no-unused-class
import s from './Banner.scss';
import { BANNER_ALT } from '../../../../constants';

const LinkWrapper = ({ link, children }) =>
  link ? <Link to={link}>{children}</Link> : <>{children}</>;

const Image = ({ src, title }) => (
  <img src={src} alt={`${title} banner`} className={s.bannerImg} />
);
// only render when client device is known
const isRendered = (client, device, src) => client && device && src;
const BannerImage = withResponsiveWrapper()(
  ({
    isClient,
    isDesktop,
    isMobile,
    imageProps: { link = '', desktop, mobile, alt } = {},
  }) => {
    const mappedLink = mapLinkToDisplayCatalog(link);
    const renderDesktopBanner = isRendered(isClient, isDesktop, desktop);
    const renderMobileBanner = isRendered(isClient, isMobile, mobile);

    return (
      <>
        {renderDesktopBanner && (
          <LinkWrapper link={mappedLink}>
            <Image src={desktop} title={alt || BANNER_ALT} />
          </LinkWrapper>
        )}
        {renderMobileBanner && (
          <LinkWrapper link={mappedLink}>
            <Image src={mobile} title={alt} />
          </LinkWrapper>
        )}
      </>
    );
  },
);

const Banner = ({ banner }) =>
  banner.length > 1 ? (
    <Carousel
      rootClass={s.carousel}
      dotsClass={s.dots}
      arrowsClass={s.arrows}
      dots
      arrows
    >
      {banner.map(({ id, ...rest }) => (
        <BannerImage key={id} imageProps={rest} />
      ))}
    </Carousel>
  ) : (
    <BannerImage imageProps={banner[0]} />
  );

LinkWrapper.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

BannerImage.propTypes = {
  imageProps: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
    alt: PropTypes.string,
    id: PropTypes.number,
    link: PropTypes.string,
  }).isRequired,
  isClient: PropTypes.bool,
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
};
Banner.propTypes = {
  banner: PropTypes.arrayOf(
    PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
      alt: PropTypes.string,
      id: PropTypes.number,
      link: PropTypes.string,
    }),
  ).isRequired,
};

export default compose(withStyles(s))(Banner);
